import { FIFTEEN_MINS_IN_EPOCH } from '../constants';

export const isShiftCompleted = (endTime) => endTime + FIFTEEN_MINS_IN_EPOCH < Date.now(); // 15 min after the end time
export const isShiftStarted = (shiftStart) => shiftStart - FIFTEEN_MINS_IN_EPOCH < Date.now(); // 15 min before the start time
